import React, {Component, Fragment} from 'react'
import PropTypes from 'prop-types'
import {Tooltip} from 'antd'
import ProcessingTime from './ProcessingTime'

class StatusStyle extends Component {
    state = {
        hovering: false
    }

    handleHovering = (isHover) => {
        this.setState({
            hovering: isHover
        })
    }

    _mapStatus = () => {
        const {hovering} = this.state
        const {status, note, processing_at} = this.props

        if (!status) {
            return null
        }

        let output = ''
        switch (status) {
            case 'error':
            case 'archived':
                output = <span className="badge badge-danger badge-pill">{status}</span>
                break
            case 'fully-done':
            case 'done':
            case 'printed':
            case 'completed':
                output = <span className="badge badge-success badge-pill">{status}</span>
                break
            case 'pending':
            case 'retry':
            case 'waiting':
                output = <span
                    className="badge badge-info badge-pill progress-bar-animated progress-bar-striped">{status}</span>
                break
            case 'processing':
                output = (!processing_at) ?
                    <span className="badge badge-primary badge-pill progress-bar-animated progress-bar-striped">{status}</span> :
                    <Tooltip 
                        placement='topLeft'
                        title={<ProcessingTime processingAt={processing_at} hovering={hovering}/>}
                        onMouseEnter={() => this.handleHovering(true)}
                        onMouseLeave={() => this.handleHovering(false)}
                    >
                        <span className="badge badge-primary badge-pill progress-bar-animated progress-bar-striped cursor-pointer">{status}</span>
                    </Tooltip>
                break
            case 'on-hold':
            case 'unprinted':
            case 'pushed':
            case 'disabled':
                output = <span className="badge badge-secondary badge-pill">{status}</span>
                break
            case 'review':
                output = <span
                    className="badge badge-warning badge-pill progress-bar-animated progress-bar-striped">{status}</span>
                break
            case 'cancelled':
                output = note ?
                    <Tooltip title={note} placement='top'><span className="badge badge-dark badge-pill">{status}</span></Tooltip>
                    : <span className="badge badge-dark badge-pill">{status}</span>
                break
            case 'free':
                output = <span
                    className="badge badge-primary badge-pill">{status}</span>
                break
            case 'printing':
                output = <span
                    className="badge printing badge-pill">{status}</span>
                break
            case 'transferring':
                output = <span
                    className="badge transferring badge-pill">{status}</span>
                break
            case 'transferred':
                output = <span
                    className="badge transferred badge-pill">{status}</span>
                break
            case 'confirmed':
                output = <span
                    className="badge confirmed badge-pill">{status}</span>
                break
            case 'wait_to_sew':
                output = <span
                    className="badge wait-sew badge-pill progress-bar-animated progress-bar-striped">{status}</span>
                break
            case 'sewing':
                output = <span
                    className="badge sewing badge-pill">{status}</span>
                break
            case 'cancel-ship':
                output = <span
                    className="badge cancel-ship badge-pill">{status}</span>
                break
            case 'moved':
                output = <span
                    className="badge moved badge-pill">{status}</span>
                break
            default:
                output = <span className={`badge ${status || 'other'} badge-pill`}>{status}</span>
        }

        return output
    }

    render() {
        const status = this._mapStatus()

        return (
            <Fragment>
                {status}
            </Fragment>
        )
    }
}

StatusStyle.defaultProps = {
    note: ''
}

StatusStyle.propTypes = {
    status: PropTypes.string,
    note: PropTypes.string
}

export default StatusStyle
